"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingReducer = void 0;
const trackingAction_1 = require("../actions/trackingAction");
const initState = {};
const trackingReducer = (tracking = initState, action) => {
    return (action === null || action === void 0 ? void 0 : action.type) === trackingAction_1.ADD_TRACKING_PARAMS ? action.payload : tracking;
};
exports.trackingReducer = trackingReducer;
//# sourceMappingURL=tracking.reducer.js.map